import { OrderService } from "entities/OrderService";

export const useOrderServiceType = (record) => {
	const isCS = record?.service === OrderService.coldStorage;
	const isPlukk = record?.service === OrderService.intoPlukkStorage;
	const isCrossDock = record?.service === OrderService.crossDock;
	const isIncomingPlukk = isPlukk && !!record?.eta_date;
	const isOutgoingPlukk = isPlukk && !!record?.etd_date;
	const isCSOrIncomingPlukk = isCS || isIncomingPlukk;
	return { isCS, isPlukk, isCrossDock, isIncomingPlukk, isOutgoingPlukk, isCSOrIncomingPlukk };
};
